import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './cancelation.scss'
const Cancelations = (props) => {
    const handleAction = (status) => {
        props.setPolicyChecked(status)
        props.setPolicyModal(false)
    }
    return (
        <>
            <Modal show={props.policyModal} size="sm">
                <Modal.Header onClick={()=>props.setPolicyModal(false)} closeButton>
                </Modal.Header>

                <Modal.Body>
                    <div className='cancelation-policy-wrapper'>
                        <div className='cancelation-title'>Cancelation Policy</div>
                        <div className='cancelation-content'>
                           <p>{props?.policyText}</p>
                        </div>
                        <div className='cancelation-btn-wrap'>
                            <Button variant='outline-primary' onClick={()=>handleAction(false)}>Decline</Button>
                            <Button variant='primary' onClick={()=>handleAction(true)}>Accept</Button>
                        </div>
                    </div>


                </Modal.Body>


            </Modal>
        </>
    )
}

export default Cancelations
